<template>
  <b-container v-if="!initialized || notifications.length" fluid class="notifications-container mt-4 pt-3">
    <b-row>
      <b-col cols="12">
        <proa-heading sub class="mb-3 pb-1">{{ $t('pages.mySpace.notifications') }}</proa-heading>
        <div v-if="!initialized" class="loading-wrapper">
          <proa-loading class="loading"/>
        </div>
        <notifications-card
          :notifications="notifications"
          :limited="limited"
          :enableChangeLimit="notificationsCount > 10"
          :key="notificationsKey"
          @changeLimited="toValue => limited = toValue"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex'
import UserNotification from '@/store/models/UserNotification'
import NotificationsCard from '@/components/molecules/NotificationsCard'

export default {
  name: 'MySpaceNotifications',
  components: {
    NotificationsCard
  },
  computed: {
    notificationsCount: function() {
      return UserNotification.query().count()
    },
    notifications: function() {
      if (!this.initialized) return []
      return UserNotification.query()
                             .orderBy('id', 'desc')
                             .limit(this.limited ? 10 : this.notificationsCount)
                             .get()
    },
  },
  data(){
    return {
      initialized: false,
      keyReloadInterval: null,
      notificationsKey: 0,
      limited: true
    }
  },
  methods: {
    ...mapActions({
      apiGetUserNotifications: 'entities/userNotifications/index'
    })
  },
  async created() {
    if (UserNotification.all().length) this.initialized = true

    await this.apiGetUserNotifications()

    this.initialized = true

    // NOTE: 毎分再描画で~分前を更新する
    this.keyReloadInterval = setInterval(() => {
      this.notificationsKey++
    }, 60000)
  },
  beforeDestroy() {
    clearInterval(this.keyReloadInterval)
  }
}
</script>

<style scoped lang="scss">
.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 40px;

  .loading {
    width: 80px;
    height: 80px;
  }
}
.notifications-container {
  padding: 0;
}
</style>
